import angular from 'angular';


import FooterController from './FooterController';

/* @ngInject */
export default angular.module('app.common.footer', [])
    .controller('FooterController', FooterController)

    .run(($templateCache) => {
        $templateCache.put('app/common/footer/footer.html', require('./footer.html')); // eslint-disable-line global-require
        $templateCache.put('app/common/footer/legalDocuments/legalDocuments.html', require('./legalDocuments/legalDocuments.html')); // eslint-disable-line global-require
        $templateCache.put('app/common/footer/legalDocuments/eSignatureDisclosures.html', require('./legalDocuments/eSignatureDisclosures.html')); // eslint-disable-line global-require
    })
    .name;



// WEBPACK FOOTER //
// ./src/app/common/footer/index.js